import { render, staticRenderFns } from "./logistics-supplementary-registration.vue?vue&type=template&id=23d9cd95&"
import script from "./logistics-supplementary-registration.vue?vue&type=script&lang=js&"
export * from "./logistics-supplementary-registration.vue?vue&type=script&lang=js&"
import style0 from "./logistics-supplementary-registration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports